import { render, staticRenderFns } from "./WarningWrapper.vue?vue&type=template&id=6e162bc6&scoped=true"
import script from "./WarningWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarningWrapper.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e162bc6",
  null
  
)

export default component.exports